/* ===========================
  POPUP COLLIERS/CORDONS PERSO
  =========================== */
(function ColliersPersoPopup() {
  const WRAP_SELECTOR =
    ".pplr-wrapper.pplr--colliersperso,.pplr-wrapper.pplr-colliersperso,.pplr-wrapper.pplr-cordonsperso";
  const POPUP_ID = "rk-colliers-modal";
  const SLOT_CLASS = "rk-collier-slot";
  const BTN_CLASS = "rk-select-collier rk-btn-collier";
  const state = new WeakMap();

  // SVG bouton COLLIERS (celui que tu avais déjà)
  const SVG_COLLIER =
    `<svg id="Calque_2" data-name="Calque 2" xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 150 150">
      <defs>
        <style>
          .cls-1 {
            fill: #dca59a;
            stroke-width: 0px;
          }
        </style>
      </defs>
      <path class="cls-1" d="M120,128.8H30c-9.3,0-16.9-7.6-16.9-16.9V39.2c0-9.3,7.6-16.9,16.9-16.9h90.1c9.3,0,16.9,7.6,16.9,16.9v72.6c0,9.3-7.6,16.9-16.9,16.9ZM30,24.1c-8.3,0-15,6.7-15,15v72.6c0,8.3,6.7,15,15,15h90.1c8.3,0,15-6.7,15-15V39.2c0-8.3-6.7-15-15-15H30Z"/>
      <path class="cls-1" d="M76.1,39.3v8h7.7v2h-7.7v8.1h-2.2v-8.1h-7.7v-2h7.7v-8h2.2Z"/>
      <g>
        <path class="cls-1" d="M46.6,80.7l-1.5,4.4h-1.9l4.8-14h2.2l4.8,14h-1.9l-1.5-4.4h-5ZM51.2,79.3l-1.4-4c-.3-.9-.5-1.7-.7-2.6h0c-.2.8-.4,1.7-.7,2.5l-1.4,4h4.2Z"/>
        <path class="cls-1" d="M54.5,88c.8,0,1.6-.3,2-.8.5-.6.7-1.4.7-3.8v-8.4h1.8v9.1c0,1.9-.3,3.2-1.2,4.1-.8.8-2.1,1.1-3.1,1.1l-.2-1.4ZM59.2,72.2c0,.6-.4,1.1-1.1,1.1s-1.1-.5-1.1-1.1.5-1.1,1.2-1.1,1.1.5,1.1,1.1Z"/>
        <path class="cls-1" d="M71.1,80c0,3.7-2.6,5.3-5,5.3s-4.8-2-4.8-5.2,2.2-5.3,5-5.3,4.8,2.1,4.8,5.2ZM63.1,80.1c0,2.2,1.3,3.9,3.1,3.9s3-1.6,3-3.9-.9-3.9-3-3.9-3.1,2-3.1,3.9Z"/>
        <path class="cls-1" d="M81.8,82.3c0,1,0,1.9,0,2.7h-1.6v-1.6h-.1c-.5.8-1.5,1.9-3.3,1.9s-3.5-.9-3.5-4.4v-5.9h1.8v5.6c0,1.9.6,3.2,2.2,3.2s2.1-.9,2.4-1.7c.1-.3.2-.6.2-.9v-6.2h1.8v7.3Z"/>
        <path class="cls-1" d="M87,72.2v2.9h2.6v1.4h-2.6v5.4c0,1.2.4,1.9,1.4,1.9s.8,0,1.1-.1v1.4c-.3.1-.8.3-1.5.3s-1.5-.3-2-.8c-.5-.5-.7-1.4-.7-2.6v-5.5h-1.6v-1.4h1.6v-2.4l1.8-.5Z"/>
        <path class="cls-1" d="M92.5,80.4c0,2.5,1.6,3.5,3.4,3.5s2.1-.2,2.8-.5l.3,1.3c-.6.3-1.7.6-3.3.6-3.1,0-4.9-2-4.9-5.1s1.8-5.4,4.7-5.4,4.1,2.9,4.1,4.7,0,.7,0,.9h-7.1ZM97.9,79.1c0-1.2-.5-3-2.5-3s-2.7,1.7-2.8,3h5.3Z"/>
        <path class="cls-1" d="M101.9,78.2c0-1.2,0-2.2,0-3.1h1.6v2h.1c.5-1.3,1.6-2.2,2.8-2.2s.4,0,.5,0v1.7c-.2,0-.4,0-.6,0-1.3,0-2.2,1-2.4,2.3,0,.2,0,.5,0,.8v5.4h-1.8v-6.9Z"/>
        <path class="cls-1" d="M37.3,105.1c0,1,0,1.9,0,2.7h-1.6v-1.6h-.1c-.5.8-1.5,1.9-3.3,1.9s-3.5-.9-3.5-4.4v-5.9h1.8v5.6c0,1.9.6,3.2,2.2,3.2s2.1-.9,2.4-1.7c.1-.3.2-.6.2-.9v-6.2h1.8v7.3Z"/>
        <path class="cls-1" d="M40.3,100.5c0-1,0-1.9,0-2.7h1.6v1.7h.1c.5-1,1.7-1.9,3.3-1.9s3.5.8,3.5,4.3v6h-1.8v-5.8c0-1.6-.6-3-2.3-3s-2.1.9-2.4,1.9c0,.2-.1.5-.1.9v6h-1.8v-7.3Z"/>
        <path class="cls-1" d="M52.8,103.1c0,2.5,1.6,3.5,3.4,3.5s2.1-.2,2.8-.5l.3,1.3c-.6.3-1.7.6-3.3.6-3.1,0-4.9-2-4.9-5.1s1.8-5.4,4.7-5.4,4.1,2.9,4.1,4.7,0,.7,0,.9h-7.1ZM58.2,101.8c0-1.2-.5-3-2.5-3s-2.7,1.7-2.8,3h5.3Z"/>
        <path class="cls-1" d="M73.8,107.4c-.5.2-1.5.6-2.9.6-3,0-5-2.1-5-5.1s2.1-5.3,5.4-5.3,2,.3,2.5.5l-.4,1.4c-.4-.2-1.1-.5-2.1-.5-2.3,0-3.5,1.7-3.5,3.8s1.5,3.8,3.5,3.8,1.7-.3,2.2-.5l.3,1.4Z"/>
        <path class="cls-1" d="M75.9,93.1h1.8v6.3h0c.3-.5.7-1,1.3-1.3.5-.3,1.2-.5,1.9-.5,1.3,0,3.5.8,3.5,4.3v6h-1.8v-5.8c0-1.6-.6-3-2.3-3s-2.1.8-2.4,1.8c-.1.2-.1.5-.1.9v6.1h-1.8v-14.7Z"/>
        <path class="cls-1" d="M93,107.8v-1.3h-.2c-.6.8-1.6,1.5-3.1,1.5-2,0-3.1-1.4-3.1-2.9,0-2.4,2.2-3.8,6-3.7v-.2c0-.8-.2-2.3-2.3-2.3s-1.9.3-2.6.7l-.4-1.2c.8-.5,2-.9,3.3-.9,3.1,0,3.8,2.1,3.8,4.1v3.8c0,.9,0,1.7.2,2.4h-1.7ZM92.7,102.7c-2,0-4.3.3-4.3,2.3s.8,1.7,1.7,1.7,2.1-.8,2.4-1.7c0-.2.1-.4.1-.6v-1.7Z"/>
        <path class="cls-1" d="M99.4,95c0,.6-.4,1.1-1.2,1.1s-1.1-.5-1.1-1.1.5-1.1,1.1-1.1,1.1.5,1.1,1.1ZM97.4,107.8v-10h1.8v10h-1.8Z"/>
        <path class="cls-1" d="M102.3,100.5c0-1,0-1.9,0-2.7h1.6v1.7h.1c.5-1,1.7-1.9,3.3-1.9s3.5.8,3.5,4.3v6h-1.8v-5.8c0-1.6-.6-3-2.3-3s-2.1.9-2.4,1.9c0,.2-.1.5-.1.9v6h-1.8v-7.3Z"/>
        <path class="cls-1" d="M114.8,103.1c0,2.5,1.6,3.5,3.4,3.5s2.1-.2,2.8-.5l.3,1.3c-.6.3-1.7.6-3.3.6-3.1,0-4.9-2-4.9-5.1s1.8-5.4,4.7-5.4,4.1,2.9,4.1,4.7,0,.7,0,.9h-7.1ZM120.1,101.8c0-1.2-.5-3-2.5-3s-2.7,1.7-2.8,3h5.3Z"/>
      </g>
    </svg>`.trim();

  // SVG bouton CORDONS (celui que tu viens de donner)
  const SVG_CORDON = `
  <svg id="Calque_1" data-name="Calque 1" xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 150 150">
    <defs>
      <style>
        .cls-1 {
          fill: #dca59a;
          stroke-width: 0px;
        }
      </style>
    </defs>
    <path class="cls-1" d="M120.3,128.5H29.7c-9.4,0-17-7.6-17-17V38.5c0-9.4,7.6-17,17-17h90.6c9.4,0,17,7.6,17,17v73c0,9.4-7.6,17-17,17ZM29.7,23.4c-8.3,0-15.1,6.8-15.1,15.1v73c0,8.3,6.8,15.1,15.1,15.1h90.6c8.3,0,15.1-6.8,15.1-15.1V38.5c0-8.3-6.8-15.1-15.1-15.1H29.7Z"/>
    <path class="cls-1" d="M76.1,38.6v8h7.7v2.1h-7.7v8.1h-2.2v-8.1h-7.7v-2.1h7.7v-8h2.2Z"/>
    <g>
      <path class="cls-1" d="M46.5,80.2l-1.5,4.4h-1.9l4.8-14.1h2.2l4.8,14.1h-1.9l-1.5-4.4h-5ZM51.1,78.8l-1.4-4c-.3-.9-.5-1.8-.7-2.6h0c-.2.8-.4,1.7-.7,2.5l-1.4,4.1h4.2Z"/>
      <path class="cls-1" d="M54.4,87.5c.8,0,1.6-.3,2-.8.5-.6.7-1.4.7-3.8v-8.4h1.8v9.2c0,2-.3,3.2-1.2,4.1-.8.8-2.1,1.1-3.1,1.1l-.2-1.4ZM59.1,71.7c0,.6-.4,1.1-1.1,1.1s-1.1-.5-1.1-1.1.5-1.1,1.2-1.1,1.1.5,1.1,1.1Z"/>
      <path class="cls-1" d="M71,79.5c0,3.7-2.6,5.4-5,5.4s-4.8-2-4.8-5.2,2.2-5.4,5-5.4,4.9,2.1,4.9,5.2ZM63,79.6c0,2.2,1.3,3.9,3.1,3.9s3.1-1.6,3.1-3.9-.9-3.9-3-3.9-3.1,2-3.1,3.9Z"/>
      <path class="cls-1" d="M81.8,81.9c0,1,0,2,0,2.8h-1.6v-1.6h-.1c-.5.8-1.5,1.9-3.3,1.9s-3.5-.9-3.5-4.4v-5.9h1.8v5.6c0,1.9.6,3.2,2.3,3.2s2.1-.9,2.4-1.7c.1-.3.2-.6.2-.9v-6.2h1.8v7.3Z"/>
      <path class="cls-1" d="M87.1,71.6v2.9h2.6v1.4h-2.6v5.4c0,1.2.4,2,1.4,2s.8,0,1.1-.1v1.4c-.3.1-.8.3-1.5.3s-1.5-.3-2-.8c-.5-.5-.7-1.4-.7-2.6v-5.5h-1.6v-1.4h1.6v-2.4l1.8-.5Z"/>
      <path class="cls-1" d="M92.6,79.9c0,2.5,1.6,3.5,3.5,3.5s2.1-.2,2.8-.5l.3,1.3c-.6.3-1.8.6-3.4.6-3.1,0-5-2-5-5.1s1.8-5.4,4.7-5.4,4.2,2.9,4.2,4.8,0,.7,0,.9h-7.1ZM98,78.6c0-1.2-.5-3-2.5-3s-2.7,1.7-2.8,3h5.4Z"/>
      <path class="cls-1" d="M102.1,77.7c0-1.2,0-2.2,0-3.1h1.6v2h.1c.5-1.4,1.6-2.2,2.8-2.2s.4,0,.5,0v1.7c-.2,0-.4,0-.6,0-1.3,0-2.2,1-2.5,2.4,0,.2,0,.5,0,.9v5.4h-1.8v-6.9Z"/>
      <path class="cls-1" d="M40.2,102.7c0,1,0,2,0,2.8h-1.6v-1.6h-.1c-.5.8-1.5,1.9-3.3,1.9s-3.5-.9-3.5-4.4v-5.9h1.8v5.6c0,1.9.6,3.2,2.3,3.2s2.1-.9,2.4-1.7c.1-.3.2-.6.2-.9v-6.2h1.8v7.3Z"/>
      <path class="cls-1" d="M43.2,98.1c0-1,0-1.9,0-2.7h1.6v1.7h.1c.5-1,1.7-1.9,3.3-1.9s3.6.8,3.6,4.3v6h-1.8v-5.8c0-1.6-.6-3-2.3-3s-2.1.9-2.5,1.9c0,.2-.1.5-.1.9v6.1h-1.8v-7.4Z"/>
      <path class="cls-1" d="M66.4,105.1c-.5.2-1.5.6-2.9.6-3,0-5-2.1-5-5.2s2.1-5.4,5.4-5.4,2,.3,2.5.5l-.4,1.4c-.4-.2-1.1-.5-2.1-.5-2.3,0-3.6,1.7-3.6,3.8s1.5,3.8,3.5,3.8,1.7-.3,2.3-.5l.3,1.4Z"/>
      <path class="cls-1" d="M77.6,100.3c0,3.7-2.6,5.4-5,5.4s-4.8-2-4.8-5.2,2.2-5.4,5-5.4,4.9,2.1,4.9,5.2ZM69.6,100.4c0,2.2,1.3,3.9,3.1,3.9s3.1-1.6,3.1-3.9-.9-3.9-3-3.9-3.1,2-3.1,3.9Z"/>
      <path class="cls-1" d="M79.9,98.5c0-1.2,0-2.2,0-3.2h1.6v2h.1c.5-1.4,1.6-2.2,2.8-2.2s.4,0,.5,0v1.7c-.2,0-.4,0-.6,0-1.3,0-2.2,1-2.5,2.4,0,.2,0,.5,0,.9v5.4h-1.8v-6.9Z"/>
      <path class="cls-1" d="M95.2,90.7v12.2c0,.9,0,1.9,0,2.6h-1.6v-1.8h-.1c-.6,1.1-1.8,2-3.4,2-2.4,0-4.3-2.1-4.3-5.1,0-3.4,2.1-5.4,4.5-5.4s2.6.7,3,1.5h0v-6h1.8ZM93.4,99.5c0-.2,0-.5,0-.8-.3-1.2-1.3-2.1-2.6-2.1s-3,1.7-3,3.9,1,3.7,3,3.7,2.4-.8,2.7-2.2c0-.2,0-.5,0-.8v-1.8Z"/>
      <path class="cls-1" d="M107.4,100.3c0,3.7-2.6,5.4-5,5.4s-4.8-2-4.8-5.2,2.2-5.4,5-5.4,4.9,2.1,4.9,5.2ZM99.4,100.4c0,2.2,1.3,3.9,3.1,3.9s3.1-1.6,3.1-3.9-.9-3.9-3-3.9-3.1,2-3.1,3.9Z"/>
      <path class="cls-1" d="M109.7,98.1c0-1,0-1.9,0-2.7h1.6v1.7h.1c.5-1,1.7-1.9,3.3-1.9s3.6.8,3.6,4.3v6h-1.8v-5.8c0-1.6-.6-3-2.3-3s-2.1.9-2.5,1.9c0,.2-.1.5-.1.9v6.1h-1.8v-7.4Z"/>
    </g>
  </svg>`.trim();

  function ensureStyles() {
    if (document.getElementById("rk-colliers-css")) return;
    const css = `
    <style id="rk-colliers-css">
      /*
       * Wrappers PPLR hors-écran mais ACCESSIBLES au JS.
       * position:absolute garantit offsetParent !== null → chooseimage() met à jour le prix.
       * opacity:0 + left:-9999px les rend invisibles à l'utilisateur.
       */
      .pplr-wrapper.pplr--colliersperso,
      .pplr-wrapper.pplr-colliersperso,
      .pplr-wrapper.pplr-cordonsperso {
        position:absolute!important;
        left:-9999px!important;
        top:0!important;
        opacity:0!important;
        pointer-events:none!important;
      }
      .rk-overlay{position:fixed;inset:0;background:rgba(0,0,0,.45);display:none;align-items:center;justify-content:center;z-index:9999}
      .rk-modal{width:92%;max-width:560px;background:#fff;border-radius:16px;box-shadow:0 10px 30px rgba(0,0,0,.18);overflow:hidden}
      .rk-modal__head{display:flex;justify-content:flex-start;gap:10px;padding:14px 18px;color:#d49a8f}
      .rk-modal__close{background:none;border:none;font:inherit;color:#d49a8f;cursor:pointer}
      .rk-modal__body{padding:6px 18px 20px 18px;max-height:70vh;overflow:auto}

      .rk-chain{position:relative;display:flex;flex-direction: column;align-items:center;gap:16px;background:#fff;border-radius:14px;padding:14px;border:1px solid #f1e7e5;box-shadow:0 6px 18px rgba(0,0,0,.06);transition:transform .06s ease}
      .rk-chain:not(:last-child){margin-bottom:14px}
      .rk-chain:active{transform:scale(.995)}
      .rk-chain__img{height:40px;width:75%;background-size:contain;background-position:center;background-repeat:no-repeat;filter:drop-shadow(0 1px 0 rgba(0,0,0,.04))}
      .rk-chain__label{font-size:14px;line-height:1.2;color:#333}
      .rk-chain__price{font-size:14px;color:#666}
      .rk-chain__remove{position:absolute;top:6px;right:6px;width:28px;height:28px;border-radius:50%;border:1px solid #e8d5d1;background:#fff;color:#d49a8f;font-size:18px;line-height:26px;text-align:center;cursor:pointer}
      .rk-chain__remove:hover{background:#fff5f3}

      .${BTN_CLASS.replace(
        /\s/g,
        ".",
      )}{display:inline-flex;align-items:center;justify-content:center;gap:8px;width:100%;margin:10px 0 14px;padding:12px 14px;border-radius:999px;border:1px solid #DCA59A;background:#fff;color:#DCA59A;font-size:14px;cursor:pointer;box-shadow:0 4px 14px rgba(0,0,0,.06)}
      .${SLOT_CLASS}{margin:0 0 6px}

      @media (min-width:720px){
        .rk-modal__body{max-height:72vh}
        .rk-chain__img{height:40px}
      }
      .rk-chain{display:flex;width: 100%;align-items:center;gap:16px;background:#fff;border-radius:14px;padding:14px;border:1px solid #f1e7e5;box-shadow:0 6px 18px rgba(0,0,0,.06);cursor:pointer;transition:transform .06s ease}
      .rk-chain__txt{flex:1 1 auto;display:flex;justify-content: center;
    gap: 4px;
    align-items: center;}

      .${BTN_CLASS.replace(
        /\s/g,
        ".",
      )}{display:inline-flex;align-items:center;justify-content:center;gap:8px;width:100%;margin:10px 0 14px;padding:12px 14px;border-radius:999px;border:1px solid #DCA59A;background:#fff;color:#DCA59A;font-size:14px;cursor:pointer;box-shadow:0 4px 14px rgba(0,0,0,.06)}
      .${SLOT_CLASS}{margin:0 0 6px}
    </style>`;
    document.head.insertAdjacentHTML("beforeend", css);
  }

  function ensureModal() {
    if (document.getElementById(POPUP_ID)) return;
    const html = `
      <div class="rk-overlay" id="${POPUP_ID}" role="dialog" aria-modal="true">
        <div class="rk-modal" role="document">
          <div class="rk-modal__head">
            <button class="rk-modal__close" type="button" aria-label="Fermer">Fermer</button>
          </div>
          <div class="rk-modal__body" id="rk-colliers-list"></div>
        </div>
      </div>`;
    document.body.insertAdjacentHTML("beforeend", html);
    const overlay = document.getElementById(POPUP_ID);
    overlay.addEventListener("click", (e) => {
      if (e.target.id === POPUP_ID) closeModal();
    });
    overlay
      .querySelector(".rk-modal__close")
      .addEventListener("click", closeModal);
    document.addEventListener("keydown", (e) => {
      if (e.key === "Escape") closeModal();
    });
  }

  function moneyCHF(n) {
    n = Number(n || 0);
    return "CHF " + n.toFixed(2);
  }

  function ensureSlot(wrap) {
    let slot = wrap.previousElementSibling;
    if (!slot || !slot.classList || !slot.classList.contains(SLOT_CLASS)) {
      slot = document.createElement("div");
      slot.className = SLOT_CLASS;
      wrap.parentNode.insertBefore(slot, wrap);
    }
    return slot;
  }

  // 2) bouton conditionnel selon le type de wrapper
  function createSelectButton(wrap) {
    const btn = document.createElement("button");
    btn.type = "button";
    btn.setAttribute("aria-haspopup", "dialog");

    const isCollier =
      wrap.classList.contains("pplr-colliersperso") ||
      wrap.classList.contains("pplr--colliersperso");

    const isCordon =
      wrap.classList.contains("pplr--cordons-perso") ||
      wrap.classList.contains("pplr-cordonsperso");
    btn.style.width = "100px";
    btn.setAttribute("aria-haspopup", "dialog");
    btn.innerHTML = isCollier ? SVG_COLLIER : SVG_CORDON;
    btn.addEventListener("click", (e) => {
      e.preventDefault();
      openModal(wrap);
    });
    return btn;
  }

  function renderButton(wrap) {
    const slot = ensureSlot(wrap);
    slot.innerHTML = "";
    slot.appendChild(createSelectButton(wrap));
  }

  function renderSelectedCard(wrap, imgUrl, label, price) {
    const slot = ensureSlot(wrap);
    slot.innerHTML = "";
    const card = document.createElement("div");
    card.className = "rk-chain rk-chain--selected";
    card.innerHTML = `
      <span class="rk-chain__img" style="background-image:url('${imgUrl}')"></span>
      <span class="rk-chain__txt">
        <span class="rk-chain__label">${label || "Option"}</span>
        <span class="rk-chain__price prix${price}">${moneyCHF(price)}</span>
      </span>
      <button type="button" class="rk-chain__remove" aria-label="Retirer">×</button>
    `;
    card.querySelector(".rk-chain__remove").addEventListener("click", (e) => {
      e.stopPropagation();
      clearSelection(wrap);
    });
    card.addEventListener("click", () => {
      openModal(wrap);
    });
    slot.appendChild(card);
  }

  function getSelectedSwatch(wrap) {
    return wrap.querySelector(
      ".pplr_thumb_image .pplr-swatch-element.pplrimage.selected:not(.pplr_deselect)",
    );
  }

  function syncCardFromWrap(wrap) {
    const selected = getSelectedSwatch(wrap);
    if (!selected) {
      renderButton(wrap);
      return;
    }
    const imgUrl = selected.getAttribute("data-image") || "";
    const label =
      selected.getAttribute("data-val") ||
      (selected.querySelector(".ppdata")?.textContent || "").trim();
    const price = selected.getAttribute("data-pplr_price");
    renderSelectedCard(wrap, imgUrl, label, price);
  }

  /**
   * Même logique que les charms: on résout le swatch vivant au clic,
   * puis on clique l'élément actuel rendu par PPLR.
   */
  function triggerSwatchSelection(wrap, targetVal, targetImage) {
    if (!wrap) return;
    const liveSwatches = wrap.querySelectorAll(
      ".pplr_thumb_image .pplr-swatch-element.pplrimage:not(.pplr_deselect)",
    );
    const live = Array.from(liveSwatches).find((candidate) => {
      const val = candidate.getAttribute("data-val") || "";
      const img = candidate.getAttribute("data-image") || "";
      return (
        (targetVal && val === targetVal) ||
        (!targetVal && targetImage && img === targetImage)
      );
    });
    if (!live) return;
    const price = parseFloat(live.getAttribute("data-pplr_price") || "0");
    if (typeof window.chooseimage === "function") {
      window.chooseimage(live, price);
    }
  }

  function showCordonSizeStep() {
    const list = document.getElementById("rk-colliers-list");
    list.innerHTML = "";

    const title = document.createElement("p");
    title.textContent = "Choisissez une taille de cordon :";
    title.style.cssText =
      "color:#d49a8f;font-size:15px;margin:0 0 16px 0;font-weight:600;text-align:center";
    list.appendChild(title);

    ["Femme", "Homme", "Enfant"].forEach((size) => {
      const btn = document.createElement("button");
      btn.type = "button";
      btn.className = "rk-chain";
      btn.innerHTML = `<span class="rk-chain__txt"><span class="rk-chain__label">${size}</span></span>`;
      btn.addEventListener("click", () => {
        const sizeSelect = document.querySelector(
          'select[name="properties[cordon-size]"]',
        );
        if (sizeSelect) {
          sizeSelect.value = size;
          sizeSelect.dispatchEvent(new Event("change", { bubbles: true }));
        }
        closeModal();
      });
      list.appendChild(btn);
    });
  }

  function populateListAndOpen(wrap) {
    ensureModal();
    const list = document.getElementById("rk-colliers-list");
    list.innerHTML = "";

    const isCordon =
      wrap.classList.contains("pplr--cordons-perso") ||
      wrap.classList.contains("pplr-cordonsperso");

    const swatches = Array.from(
      wrap.querySelectorAll(
        ".pplr_thumb_image .pplr-swatch-element.pplrimage:not(.pplr_deselect)",
      ),
    ).filter(
      (sw) =>
        !sw.classList.contains("vrdisabled") &&
        sw.getAttribute("data-tag") !== "novisible",
    );
    swatches.forEach((sw) => {
      const imgUrl =
        sw.getAttribute("data-image") ||
        sw.style.backgroundImage
          .replace(/^url\(["']?/, "")
          .replace(/["']?\)$/, "");
      const label =
        sw.getAttribute("data-val") ||
        (sw.querySelector(".ppdata")?.textContent || "").trim();
      const price = sw.getAttribute("data-pplr_price");

      const row = document.createElement("button");
      row.type = "button";
      row.className = "rk-chain";
      row.innerHTML = `
        <span class="rk-chain__img" style="background-image:url('${imgUrl}')"></span>
        <span class="rk-chain__txt">
          <span class="rk-chain__label">${label || "Option"}</span>
          <span class="rk-chain__price prix${price}">${moneyCHF(price)}</span>
        </span>
      `;
      row.addEventListener("click", () => {
        applySelection(wrap, sw, imgUrl, label, price);
        if (isCordon) {
          showCordonSizeStep();
        } else {
          closeModal();
        }
      });

      list.appendChild(row);
    });

    const overlay = document.getElementById(POPUP_ID);
    overlay.style.display = "flex";
    overlay.querySelector(".rk-modal__close").focus({ preventScroll: true });
  }

  function openModal(wrap) {
    populateListAndOpen(wrap);
  }

  function refreshShieldState() {
    if (typeof window.updateCollierShields === "function") {
      window.updateCollierShields();
    }
  }

  function applySelection(wrap, swatch, imgUrl, label, price) {
    const p = parseFloat(price || "0");
    if (typeof window.chooseimage === "function") {
      window.chooseimage(swatch, p);
    }
    state.set(wrap, { imgUrl, label, price: p });
    updateFormProperty(wrap, label || "");
    renderSelectedCard(wrap, imgUrl, label, p);
    refreshShieldState();
  }

  function clearSelection(wrap) {
    const deselect = wrap.querySelector(
      ".pplr_thumb_image .pplr-swatch-element.pplr_deselect",
    );
    if (deselect && typeof window.chooseimage === "function") {
      const p = parseFloat(deselect.getAttribute("data-pplr_price") || "0");
      window.chooseimage(deselect, p);
    }
    state.set(wrap, null);
    updateFormProperty(wrap, "");
    renderButton(wrap);
    refreshShieldState();
  }

  function updateFormProperty(wrap, value) {
    const form = document.querySelector('form[action="/cart/add"]');
    if (!form) return;
    const isCordon =
      wrap.classList.contains("pplr--cordons-perso") ||
      wrap.classList.contains("pplr-cordonsperso");
    const key = isCordon ? "cordon" : "collier";
    let input = form.querySelector(`input[name="properties[${key}]"]`);
    if (!input) {
      input = document.createElement("input");
      input.type = "hidden";
      input.name = `properties[${key}]`;
      form.appendChild(input);
    }
    input.value = value;
  }

  function closeModal() {
    const o = document.getElementById(POPUP_ID);
    if (o) o.style.display = "none";
  }

  // 3) init pour TOUT wrapper trouvé (colliers ou cordons)
  function init() {
    ensureStyles();
    const wraps = document.querySelectorAll(WRAP_SELECTOR);
    const garanties = document.querySelectorAll(
      ".product__block:nth-child(11),.product__block:nth-child(12)",
    );
    garanties?.forEach((element) => {
      element.style.display = "none";
    });
    if (!wraps.length) return;

    wraps.forEach((wrap) => {
      if (wrap.dataset.rkInit === "1") return;
      wrap.dataset.rkInit = "1";
      state.set(wrap, null);

      // Toujours désélectionner les chaînes/cordons par défaut à l'initialisation
      clearSelection(wrap);
    });

    // Shield system disabled - was interfering with price updates
  }

  // Synchronise en temps réel les propriétés collier/cordon uniquement
  function updateFormProperties() {
    const form = document.querySelector('form[action="/cart/add"]');
    if (!form || form.dataset.rkCollierBound === "1") return;

    form.dataset.rkCollierBound = "1";

    function syncProperties() {
      // Nettoyer les anciens inputs de colliers/cordons uniquement
      form
        .querySelectorAll(
          'input[name^="properties[collier"], input[name^="properties[cordon"]',
        )
        .forEach((input) => input.remove());

      // Récupérer les sélections actuelles de colliers/cordons
      const selectedCards = document.querySelectorAll(".rk-chain--selected");

      selectedCards.forEach((card) => {
        const label = card
          .querySelector(".rk-chain__label")
          ?.textContent?.trim();
        const price = card
          .querySelector(".rk-chain__price")
          ?.textContent?.trim();

        if (label) {
          // Déterminer le type (collier ou cordon) selon le wrapper parent
          const wrapper = card.closest(".rk-collier-slot")?.nextElementSibling;
          let propertyName = "collier";

          if (
            wrapper &&
            (wrapper.classList.contains("pplr--cordons-perso") ||
              wrapper.classList.contains("pplr-cordonsperso"))
          ) {
            propertyName = "cordon";
          }

          // Créer l'input caché en temps réel
          const input = document.createElement("input");
          input.type = "hidden";
          input.name = `properties[${propertyName}]`;
          input.value = price ? `${label} - ${price}` : label;
          form.appendChild(input);
        }
      });
    }

    // Observer UNIQUEMENT les changements de classe (pas childList pour éviter la boucle)
    // On observe seulement la zone des slots de colliers
    const observer = new MutationObserver((mutations) => {
      let shouldSync = false;

      mutations.forEach((mut) => {
        // Ne déclencher que si changement de classe sur un élément .rk-chain
        if (mut.type === "attributes" && mut.attributeName === "class") {
          const target = mut.target;
          if (target.classList && target.classList.contains("rk-chain")) {
            shouldSync = true;
          }
        }
        // Ou si ajout/retrait d'un .rk-chain--selected
        if (mut.type === "childList") {
          mut.addedNodes.forEach((node) => {
            if (
              node.nodeType === 1 &&
              node.classList &&
              node.classList.contains("rk-chain--selected")
            ) {
              shouldSync = true;
            }
          });
          mut.removedNodes.forEach((node) => {
            if (
              node.nodeType === 1 &&
              node.classList &&
              node.classList.contains("rk-chain--selected")
            ) {
              shouldSync = true;
            }
          });
        }
      });

      if (shouldSync) {
        syncProperties();
      }
    });

    // Observer seulement la zone des slots (pas tout le body, pas le form)
    const slotContainer =
      document.querySelector(".product__submit") || document.body;
    observer.observe(slotContainer, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ["class"],
    });

    // Sync initial
    syncProperties();
  }

  let rkStarted = false;

  function tryInitOnce() {
    if (rkStarted) return true;
    const hasWrap = document.querySelector(
      ".pplr-wrapper.pplr--colliersperso,.pplr-wrapper.pplr-colliersperso, .pplr-wrapper.pplr-cordonsperso",
    );
    RKCharsetToolbar();
    if (!hasWrap) return false;
    rkStarted = true;
    init(); // ← ta fonction init existante qui insère le bouton / modale et binde les événements
    CollierATCShield();
    return true;
  }

  function bootWithPolling() {
    // 1) premier essai immédiat
    if (tryInitOnce()) return;

    // 2) sinon, on tente toutes les secondes, max 10 fois
    let tries = 0;
    const iv = setInterval(() => {
      if (tryInitOnce() || ++tries >= 10) {
        clearInterval(iv);
      }
    }, 1000);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", bootWithPolling, {
      once: true,
    });
  } else {
    bootWithPolling();
  }

  /* ==========================================
   Cart & Cart Drawer → Note meta invisible + checkout
   - Marche sur la page panier ET dans le cart drawer
   - N'agit pas sur /cart/add
   ========================================== */
  (function RK_CartAndDrawer_NoteMeta() {
    const FORM_SELECTOR_SAFE = 'form[action="/cart"], form[action^="/cart?"]'; // pas /cart/add
    const VISIBLE_NOTE_SELECTOR = 'textarea#gift-note, textarea[name="note"]'; // drawer: #gift-note (attributes), page: note éventuelle
    const GIFT_TRIGGER_SELECTOR =
      '[data-collapsible-trigger][aria-controls="gift-notes"], .cart__widget__title[aria-controls="gift-notes"]';

    const MARK_START = "--- RK_ORDER_META START ---";
    const MARK_END = "--- RK_ORDER_META END ---";

    const formLock = new WeakMap(); // évite les doubles submit par form

    // --- Utils bloc caché ---
    function stripAutoBlock(text = "") {
      const re = new RegExp(`\\n*${MARK_START}[\\s\\S]*?${MARK_END}\\n*`, "g");
      return (text || "").replace(re, "").trim();
    }
    function buildAutoBlockFromDOM() {
      const lines = [];
      const items = document.querySelectorAll(".cart__item, [data-cart-item]");

      function cleanLabel(s = "") {
        return s.replace(/\s*:\s*$/, "").trim();
      }
      function filenameFromHref(href = "") {
        try {
          const url = new URL(href, location.origin);
          const last = url.pathname.split("/").pop() || "";
          return last.split("?")[0] || href;
        } catch (e) {
          const raw = (href || "").split("/").pop() || href;
          return raw.split("?")[0];
        }
      }

      items.forEach((item, idx) => {
        const title = (
          item.querySelector(".cart__item__title")?.textContent || ""
        ).trim();
        lines.push(`#${idx + 1} ${title || "Article"}`);

        const meta = item.querySelector(".cart__item__meta");
        if (!meta) return;

        const rowSet = new Set();

        // Parcourt chaque bloc de meta (p.cart__item__selected-options / p.cart__item__property / etc.)
        meta.querySelectorAll("p").forEach((p) => {
          // format général : <p><span>Label:</span><span>Valeur</span></p>
          const spans = p.querySelectorAll("span");
          let label = "";
          let value = "";

          if (spans.length >= 1) {
            label = cleanLabel(spans[0].textContent || "");
          }
          if (spans.length >= 2) {
            const valNode = spans[1];
            const a = valNode.querySelector("a");
            if (a) {
              // si lien → on affiche le nom de fichier, ou le texte s’il existe
              value =
                (a.textContent || "").trim() ||
                filenameFromHref(a.getAttribute("href") || a.href || "");
            } else {
              value = (valNode.textContent || "").trim();
            }
          } else {
            // fallback: texte direct dans <p> sans spans structurés
            const strong = p.querySelector("strong");
            if (strong) {
              label = cleanLabel(strong.textContent || "");
              value = (p.textContent || "")
                .replace(strong.textContent, "")
                .trim();
            } else if (!label) {
              value = (p.textContent || "").trim();
            }
          }

          // Nettoyage
          if (!label && !value) return;
          // évite des lignes "Label: " vides
          const row = label
            ? `• ${label}: ${value}`.trim()
            : `• ${value}`.trim();
          if (row && !rowSet.has(row)) {
            rowSet.add(row);
          }
        });

        // Ajoute les lignes nettoyées
        rowSet.forEach((r) => lines.push(r));
      });

      const payload = lines.join("\n");
      if (!payload) return "";
      return `\n\n--- RK_ORDER_META START ---\n${payload}\n--- RK_ORDER_META END ---`;
    }

    // --- API panier ---
    async function readCartNote() {
      try {
        const r = await fetch("/cart.js", {
          headers: { Accept: "application/json" },
        });
        if (!r.ok) return "";
        const data = await r.json();
        return data.note || "";
      } catch (e) {
        return "";
      }
    }
    async function updateCartNote(noteText) {
      try {
        await fetch("/cart/update.js", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ note: noteText }),
        });
      } catch (e) {}
    }

    // --- Nettoyage de ce que voit l’utilisateur (drawer / page) ---
    function cleanVisibleTextarea(scope = document) {
      const ta = scope.querySelector(VISIBLE_NOTE_SELECTOR);
      if (!ta) return;
      const cleaned = stripAutoBlock(ta.value);
      if (ta.value !== cleaned) {
        ta.value = cleaned;
        ta.dispatchEvent(new Event("input", { bubbles: true }));
        ta.dispatchEvent(new Event("change", { bubbles: true }));
      }
    }
    function bindGiftTriggerVisibility(scope = document) {
      scope.querySelectorAll(GIFT_TRIGGER_SELECTOR).forEach((btn) => {
        if (btn.dataset.rkGiftBound === "1") return;
        btn.dataset.rkGiftBound = "1";
        btn.addEventListener(
          "click",
          () => setTimeout(() => cleanVisibleTextarea(scope), 30),
          { capture: true },
        );
      });
    }
    function guardTextareaEdits(scope = document) {
      const ta = scope.querySelector(VISIBLE_NOTE_SELECTOR);
      if (!ta || ta.dataset.rkCleanBound === "1") return;
      ta.dataset.rkCleanBound = "1";
      // Seulement nettoyer au blur/change, pas pendant que l'utilisateur tape
      // Cela évite de supprimer les espaces qu'il vient de taper
      ["blur", "change"].forEach((ev) => {
        ta.addEventListener(ev, () => cleanVisibleTextarea(scope), {
          capture: true,
        });
      });
    }
    // --- Intégration submit (page & drawer) ---
    function isCartFormSafe(form) {
      const a = form.getAttribute("action") || "";
      return !/\/cart\/add(?:$|\?)/.test(a) && /^\/cart(?:$|\?)/.test(a);
    }

    async function handleSubmit(form) {
      // 1) lire note existante (panier) et nettoyer notre bloc
      const existing = stripAutoBlock(await readCartNote());
      // 2) construire le bloc à jour depuis le DOM courant
      const metaBlock = buildAutoBlockFromDOM();
      const finalNote = metaBlock
        ? existing
          ? existing + "\n\n" + metaBlock
          : metaBlock.replace(/^\n+/, "")
        : existing;

      // 3) mettre à jour le panier puis aller au checkout
      await updateCartNote(finalNote);
      window.location.assign("/checkout");
    }

    function bindForm(form) {
      if (!isCartFormSafe(form)) return;
      if (form.dataset.rkBound === "1") return;
      form.dataset.rkBound = "1";

      form.addEventListener(
        "submit",
        async (e) => {
          // lock par form
          if (formLock.get(form)) return;
          formLock.set(form, true);

          e.preventDefault();
          e.stopImmediatePropagation();

          await handleSubmit(form);
        },
        true,
      );
    }

    function bindAll(root = document) {
      // Nettoyage visible (drawer/page)
      cleanVisibleTextarea(root);
      bindGiftTriggerVisibility(root);
      guardTextareaEdits(root);

      // Formulaires (peut y en avoir 2 : page + drawer)
      root.querySelectorAll(FORM_SELECTOR_SAFE).forEach(bindForm);
    }

    // --- Boot + observer (pour le cart drawer qui s'injecte dynamiquement) ---
    function init() {
      bindAll(document);

      const mo = new MutationObserver((muts) => {
        // Si le drawer s’ouvre / se rafraîchit, on rebinde
        bindAll(document);
      });
      mo.observe(document.documentElement, { childList: true, subtree: true });
    }

    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", init);
    } else {
      init();
    }
  })();

  (function rkAutoSuppFaceArrDelay() {
    const FORM_SEL = "#AddToCartForm--template--25134776353092__main";
    const READY_TIMEOUT = 20000; // 20s max
    const CHECK_EVERY = 150;

    // ---- util: attendre que predicate() soit vrai ou timeout ----
    function waitFor(
      predicate,
      { timeout = READY_TIMEOUT, interval = CHECK_EVERY } = {},
    ) {
      return new Promise((resolve, reject) => {
        const t0 = Date.now();
        const iv = setInterval(() => {
          if (predicate()) {
            clearInterval(iv);
            resolve(true);
          } else if (Date.now() - t0 > timeout) {
            clearInterval(iv);
            reject(new Error("waitFor timeout"));
          }
        }, interval);
      });
    }

    // ---- patch setRangeText -> émet un 'input' ----
    (function patchSetRangeText() {
      const proto = HTMLTextAreaElement.prototype;
      if (!proto._rkSetRangePatched && proto.setRangeText) {
        const orig = proto.setRangeText;
        proto.setRangeText = function (...args) {
          const ret = orig.apply(this, args);
          this.dispatchEvent(new Event("input", { bubbles: true }));
          return ret;
        };
        proto._rkSetRangePatched = true;
      }
    })();

    function initCore(form) {
      // === Ton code “logique” inchangé, mais emballé ===
      function getBackTextarea() {
        return form.querySelector(
          '.pplr-wrapper.pplr-text[data-main="3"] textarea.pplr_text',
        );
      }
      function getSuppWrap() {
        return form.querySelector(".pplr-wrapper.pplr-suppfacearr");
      }
      function clickImageIfNeeded(wrap) {
        if (!wrap) return;
        const optImg = wrap.querySelector(
          ".pplr_thumb_image .pplr-swatch-element.pplrimage:not(.pplr_deselect)",
        );
        const deselect = wrap.querySelector(
          ".pplr_thumb_image .pplr-swatch-element.pplrimage.pplr_deselect",
        );
        if (deselect && deselect.classList.contains("selected") && optImg)
          optImg.click();
      }
      function clickRemoveIfNeeded(wrap) {
        if (!wrap) return;
        const deselect = wrap.querySelector(
          ".pplr_thumb_image .pplr-swatch-element.pplrimage.pplr_deselect",
        );
        if (deselect && !deselect.classList.contains("selected"))
          deselect.click();
      }
      const hasLetter = (val) => /[^\s]/.test(val || "");

      let tId = null;
      function onInput() {
        clearTimeout(tId);
        tId = setTimeout(() => {
          const ta = getBackTextarea();
          const wrap = getSuppWrap();
          if (!ta || !wrap) return;

          if (hasLetter(ta.value)) {
            clickImageIfNeeded(wrap);
          } else {
            if (!hasLetter((ta.value || "").trim())) clickRemoveIfNeeded(wrap);
          }
        }, 30);
      }
      function triggerTaInput() {
        const ta = getBackTextarea();
        if (!ta) return;
        ta.dispatchEvent(new Event("input", { bubbles: true }));
        onInput();
      }

      // hook boutons caractères spéciaux (même si ajout tardif)
      function bindCharsetToolbar() {
        if (form._rkCharsetBound) return;
        form._rkCharsetBound = true;
        form.addEventListener(
          "click",
          (e) => {
            const btn = e.target.closest(".rk-charset-toolbar .rk-ch-btn");
            if (!btn) return;
            // laisser le bouton insérer, puis signaler
            setTimeout(triggerTaInput, 0);
          },
          true,
        );
      }

      function bindTextareaAndWatch() {
        const ta = getBackTextarea();
        if (!ta || ta.dataset.rkSuppBound === "1") return;
        ta.dataset.rkSuppBound = "1";
        ["input", "change", "keyup", "blur"].forEach((ev) =>
          ta.addEventListener(ev, onInput, { passive: true }),
        );
        onInput(); // init

        // si le plugin remplace le textarea, on rebinde
        let lastVal = ta.value;
        const iv = setInterval(() => {
          const cur = getBackTextarea();
          if (!cur) return;
          if (cur !== ta && !cur.dataset.rkSuppBound) {
            clearInterval(iv);
            bindTextareaAndWatch(); // rebond
            return;
          }
          if (cur.value !== lastVal) {
            lastVal = cur.value;
            onInput();
          }
        }, 200);
      }

      bindCharsetToolbar();
      bindTextareaAndWatch();

      // MutationObserver : si Zepto réinjection, on rebinde proprement
      const mo = new MutationObserver(() => {
        bindCharsetToolbar();
        bindTextareaAndWatch();
      });
      mo.observe(form, { childList: true, subtree: true });
    }

    // ---- Démarrage robuste: DOM ready + attente des éléments ----
    function start() {
      if (start._ran) return;
      start._ran = true;
      const form = document.querySelector(FORM_SEL);
      if (!form) return; // page sans form ciblé

      waitFor(() => {
        const ta = form.querySelector(
          '.pplr-wrapper.pplr-text[data-main="3"] textarea.pplr_text',
        );
        // on peut démarrer dès que le textarea apparaît (toolbar peut venir après)
        return !!ta;
      })
        .then(() => {
          initCore(form);
        })
        .catch(() => {
          // même en timeout, on tente quand même (au cas où)
          initCore(form);
        });
    }

    // multi-stratégie: DOMContentLoaded, load, idle, et si déjà prêt
    if (
      document.readyState === "complete" ||
      document.readyState === "interactive"
    ) {
      setTimeout(start, 0);
    } else {
      document.addEventListener("DOMContentLoaded", start, { once: true });
    }
    window.addEventListener("load", start, { once: true });
    if ("requestIdleCallback" in window)
      requestIdleCallback(start, { timeout: 1500 });
  })();

  function RKCharsetToolbar() {
    const TA_SELECTOR =
      ".pplr-wrapper.pplr-text textarea.pplr_text.pplr_monogram";
    const TOOLBAR_CLASS = "rk-charset-toolbar";
    const BTN_CLASS = "rk-ch-btn";
    const garanties = document.querySelectorAll(
      ".product__block:nth-child(11),.product__block:nth-child(12)",
    );
    garanties?.forEach((element) => {
      element.style.display = "none";
    });
    function ensureCSS() {
      if (document.getElementById("rk-charset-css")) return;
      const css = `
      <style id="rk-charset-css">
        .${TOOLBAR_CLASS}{display:flex;gap:8px;margin:8px 0 0 0;flex-wrap:wrap}
        .${BTN_CLASS}{
          appearance:none;border:1px solid #DCA59A;background:#fff;color:#DCA59A;
          border-radius:10px;padding:6px 10px;font-size:14px;line-height:1;cursor:pointer;
          box-shadow:0 2px 8px rgba(0,0,0,.06); transition:transform .06s ease, background .2s;
          margin-bottom:20px;

        }
          .rk-ch-btn{font-family: Normal-v2; margin-right:10px;   font-size: 30px;}
        .${BTN_CLASS}:active{transform:scale(.98)}
        .${BTN_CLASS}:hover{background:#fff8f6}
        ${TA_SELECTOR}{font-family:Normal-v2 !important;}
        .${BTN_CLASS}[disabled]{opacity:.5;cursor:not-allowed}
      </style>`;
      document.head.insertAdjacentHTML("beforeend", css);
    }

    // Construit la toolbar pour un textarea donné (si pas déjà en place)
    function attachToolbar(ta) {
      if (!ta || ta.dataset.rkToolbar === "1") return;
      ta.dataset.rkToolbar = "1";

      const toolbar = document.createElement("div");
      toolbar.className = TOOLBAR_CLASS;
      toolbar.setAttribute("role", "group");
      toolbar.setAttribute("aria-label", "Caractères spéciaux");

      const chars = ["¤", "©", "ª", "¬", "¢"];
      chars.forEach((ch) => {
        const btn = document.createElement("button");
        btn.type = "button";
        btn.className = BTN_CLASS;
        btn.textContent = ch;
        btn.setAttribute("aria-label", `Insérer ${ch}`);

        // Empêche la perte de focus/caret (important mobile)
        btn.addEventListener("mousedown", (e) => e.preventDefault());

        btn.addEventListener("click", () => {
          insertAtCaret(ch);
        });

        toolbar.appendChild(btn);
      });

      // Insère la barre juste après le textarea
      ta.insertAdjacentElement("afterend", toolbar);
    }

    let lastTA = null;

    // Garde le dernier textarea focus + caret
    function bindTA(ta) {
      if (!ta || ta.dataset.rkBound === "1") return;
      ta.dataset.rkBound = "1";

      ta.addEventListener(
        "focus",
        () => {
          lastTA = ta;
        },
        true,
      );
      ta.addEventListener(
        "click",
        () => {
          lastTA = ta;
        },
        true,
      );
      ta.addEventListener(
        "keyup",
        () => {
          lastTA = ta;
        },
        true,
      );
      ta.addEventListener(
        "mouseup",
        () => {
          lastTA = ta;
        },
        true,
      );
    }

    function visibleTextareas() {
      return Array.from(document.querySelectorAll(TA_SELECTOR)).filter(
        (t) => t.offsetParent !== null,
      ); // visibles (Face avant / arrière)
    }

    function getTargetTA() {
      // Priorité : dernier focus
      if (
        lastTA &&
        document.body.contains(lastTA) &&
        lastTA.offsetParent !== null
      )
        return lastTA;
      // Sinon : premier textarea visible
      const vis = visibleTextareas();
      return vis[0] || null;
    }

    function insertAtCaret(text) {
      const ta = getTargetTA();
      if (!ta) return;

      const start = ta.selectionStart ?? ta.value.length;
      const end = ta.selectionEnd ?? ta.value.length;

      const valBefore = ta.value.slice(0, start);
      const valAfter = ta.value.slice(end);

      // Optionnel : si un maxlength natif existe, respectez-le
      const max = ta.getAttribute("maxlength");
      const nextVal = valBefore + text + valAfter;
      if (max && nextVal.length > parseInt(max, 10)) return;

      ta.value = nextVal;

      const newPos = start + text.length;
      ta.setSelectionRange(newPos, newPos);
      ta.focus();

      // Déclenche les hooks Zepto (oninput déjà utilisé par le plugin)
      ta.dispatchEvent(new Event("input", { bubbles: true }));
    }

    function initOnce() {
      ensureCSS();

      // Attache sur les textareas déjà présents
      document.querySelectorAll(TA_SELECTOR).forEach((ta) => {
        attachToolbar(ta);
        bindTA(ta);
      });

      // Observe mutations (le plugin peut re-render)
      const mo = new MutationObserver(() => {
        document.querySelectorAll(TA_SELECTOR).forEach((ta) => {
          attachToolbar(ta);
          bindTA(ta);
        });
      });
      mo.observe(document.documentElement, { childList: true, subtree: true });
    }

    // Boot

    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", initOnce);
    } else {
      initOnce();
    }
  }
})();

/* ===========================
   ATC Shield : bloque le bouton tant qu'aucun collier n'est choisi
   =========================== */
function CollierATCShield() {
  const WRAP_SELECTOR =
    ".pplr-wrapper.pplr--colliersperso,.pplr-wrapper.pplr-colliersperso,.pplr-wrapper.pplr-cordonsperso";
  const BTN_SELECTOR = ".product__submit__add";
  const SHIELD_CLASS = "rk-atc-shield";
  const MODAL_ID = "rk-collier-guard";

  function hasCollierSelected() {
    // Vérifie s'il y a un vrai collier/cordon sélectionné (pas juste un placeholder ou un masqué)
    const rkSelected = document.querySelectorAll(
      ".rk-collier-slot .rk-chain--selected",
    );
    for (const el of rkSelected) {
      // Ignore les placeholders ou éléments masqués
      if (
        el.offsetParent !== null &&
        !el.classList.contains("rk-chain--placeholder") &&
        !el.classList.contains("is-placeholder")
      ) {
        return true;
      }
    }
    const wrap = document.querySelector(WRAP_SELECTOR);
    if (!wrap) return false;
    const zeptoSelected = wrap.querySelectorAll(
      ".pplr_thumb_image .pplr-swatch-element.pplrimage.selected:not(.pplr_deselect)",
    );

    for (const el of zeptoSelected) {
      // Ignore les éléments masqués, désactivés ou invisibles
      if (
        el.offsetParent !== null &&
        !el.classList.contains("vrdisabled") &&
        el.getAttribute("data-tag") !== "novisible"
      ) {
        return true;
      }
    }
    return false;
  }

  function openSelectPopup() {
    const byClass = document.querySelector(".rk-select-collier");
    if (byClass) {
      byClass.click();
      return;
    }
    const slotBtn = document.querySelector(
      '.rk-collier-slot button[aria-haspopup="dialog"]',
    );
    if (slotBtn) {
      slotBtn.click();
      return;
    }
  }

  function ensureConfirmModal() {
    if (document.getElementById(MODAL_ID)) return;
    const css = `
      <style id="${MODAL_ID}-css">
        .rk-guard{position:fixed;inset:0;background:rgba(0,0,0,.45);display:none;align-items:center;justify-content:center;z-index:10000}
        .rk-guard__modal{width:92%;max-width:520px;background:#fff;border-radius:16px;box-shadow:0 10px 30px rgba(0,0,0,.18);overflow:hidden}
        .rk-guard__head{padding:16px 20px 0 20px;color:#d49a8f;font-weight:600;font-size:18px}
        .rk-guard__body{padding:10px 20px 20px 20px;color:#555;line-height:1.45}
        .rk-guard__ctas{display:flex;gap:10px;justify-content:flex-end;padding:0 20px 20px}
        .rk-guard__btn{border-radius:999px;padding:10px 16px;font-size:14px;cursor:pointer}
        .rk-guard__btn--primary{background:#DCA59A;border:1px solid #DCA59A;color:#fff}
        .rk-guard__btn--ghost{background:#fff;border:1px solid #DCA59A;color:#DCA59A}
      </style>`;
    let html = "";
    if (document.querySelector(".pplr-wrapper.pplr-cordonsperso")) {
      html = `
      <div class="rk-guard" id="${MODAL_ID}" role="dialog" aria-modal="true" aria-label="Confirmation collier">
        <div class="rk-guard__modal" role="document">
          <div class="rk-guard__head">Sans cordon ?</div>
          <div class="rk-guard__body">
            Ce bijou est actuellement <strong>sans cordon</strong>.<br>
            Vous devez selectionner un cordon.
          </div>
          <div class="rk-guard__ctas">
            <button type="button" class="rk-guard__btn rk-guard__btn--primary" data-action="add">Ajouter un cordon</button>
          </div>
        </div>
      </div>`;
    } else {
      html = `
      <div class="rk-guard" id="${MODAL_ID}" role="dialog" aria-modal="true" aria-label="Confirmation collier">
        <div class="rk-guard__modal" role="document">
          <div class="rk-guard__head">Sans chaîne ?</div>
          <div class="rk-guard__body">
            Ce bijou est actuellement <strong>sans chaîne</strong>.<br>
            Souhaitez-vous continuer sans, ou ajouter une chaîne ?
          </div>
          <div class="rk-guard__ctas">
            <button type="button" class="rk-guard__btn rk-guard__btn--ghost" data-action="continue">Continuer sans</button>
            <button type="button" class="rk-guard__btn rk-guard__btn--primary" data-action="add">Ajouter une chaîne</button>
          </div>
        </div>
      </div>`;
    }

    document.head.insertAdjacentHTML("beforeend", css);
    document.body.insertAdjacentHTML("beforeend", html);

    const overlay = document.getElementById(MODAL_ID);
    overlay.addEventListener("click", (e) => {
      if (e.target.id === MODAL_ID) overlay.style.display = "none";
    });
    document.addEventListener("keydown", (e) => {
      if (e.key === "Escape") overlay.style.display = "none";
    });
  }

  // Fonction supprimée - synchronisation en temps réel via updateFormPropertiesWithTextareas

  function openConfirm(forButton) {
    ensureConfirmModal();
    const ov = document.getElementById(MODAL_ID);
    ov.style.display = "flex";
    if (ov.querySelector('[data-action="continue"]')) {
      ov.querySelector('[data-action="continue"]').onclick = () => {
        ov.style.display = "none";
        // Clique sur le bouton remove (deselect) pour garantir qu'aucun collier n'est sélectionné
        const wrap = document.querySelector(WRAP_SELECTOR);
        if (wrap) {
          const removeBtn = wrap.querySelector(
            ".pplr_thumb_image .pplr-swatch-element.pplr_deselect",
          );
          if (removeBtn && typeof window.chooseimage === "function") {
            const p = parseFloat(
              removeBtn.getAttribute("data-pplr_price") || "0",
            );
            window.chooseimage(removeBtn, p);
          }
        }

        // Au lieu de supprimer le shield, on le désactive juste
        document
          .querySelector(".rk-atc-shield")
          .classList.add("shield-disabled");

        // Mettre à jour l'état du shield (il devrait rester désactivé car aucun collier)
        // if (typeof window.updateCollierShields === "function") {
        //   setTimeout(() => window.updateCollierShields(), 100);
        // }

        try {
          forButton.focus();
        } catch (e) {}
      };
    }

    ov.querySelector('[data-action="add"]').onclick = () => {
      ov.style.display = "none";
      openSelectPopup();
    };
  }

  // function fireAdd supprimée : plus de déclenchement programmatique.

  function ensureShieldCSS() {
    if (document.getElementById("rk-atc-shield-css")) return;
    const css = `
      <style id="rk-atc-shield-css">
        .${SHIELD_CLASS}{
          position:absolute; inset:0; z-index:5;
          background:transparent; border-radius:inherit;
          pointer-events:auto; cursor:pointer;
          transition: z-index 0.2s;
        }
        .${SHIELD_CLASS}.shield-disabled {
          z-index: -1;
          pointer-events: none;
        }
      </style>`;
    document.head.insertAdjacentHTML("beforeend", css);
  }

  function updateShieldState(shield) {
    if (!shield) return;

    if (hasCollierSelected()) {
      // Collier sélectionné : désactiver le shield
      shield.classList.add("shield-disabled");
    } else {
      // Aucun collier : activer le shield
      shield.classList.remove("shield-disabled");
    }
  }

  function ensureShieldOn(btn) {
    if (!btn) return;
    const holder = btn.closest(".product__submit__item") || btn.parentElement;
    if (!holder) return;
    holder.style.position = holder.style.position || "relative";
    ensureShieldCSS();

    let shield = holder.querySelector("." + SHIELD_CLASS);

    // Si le shield existe déjà, juste mettre à jour son état
    if (shield) {
      updateShieldState(shield);
      return shield;
    }

    // Créer le shield
    shield = document.createElement("div");
    shield.className = SHIELD_CLASS;
    shield.setAttribute("role", "button");
    shield.setAttribute("aria-label", "Ajouter au panier");

    const intercept = (e) => {
      if (!document.querySelector(WRAP_SELECTOR)) return;
      if (hasCollierSelected()) {
        // Ne rien faire si un collier est sélectionné (le shield est désactivé)
        return;
      }
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
      openConfirm(btn);
    };

    ["click", "pointerup", "touchend", "keydown"].forEach((ev) => {
      shield.addEventListener(
        ev,
        (e) => {
          if (ev === "keydown") {
            const k = e.key;
            if (k !== "Enter" && k !== " ") return;
          }
          intercept(e);
        },
        { capture: true, passive: false },
      );
    });

    holder.appendChild(shield);

    // Définir l'état initial du shield
    updateShieldState(shield);

    return shield;
  }

  function bindButton(btn) {
    if (!btn || btn.dataset.rkBound === "1") return;
    btn.dataset.rkBound = "1";
    ensureShieldOn(btn);
  }

  function bindAll() {
    const buttons = document.querySelectorAll(BTN_SELECTOR);
    buttons.forEach(bindButton);
  }

  // Fonction pour mettre à jour l'état de tous les shields
  function updateAllShields() {
    const shields = document.querySelectorAll("." + SHIELD_CLASS);
    shields.forEach((shield) => updateShieldState(shield));
  }

  // Exposer la fonction de mise à jour globalement
  window.updateCollierShields = updateAllShields;

  let tries = 0,
    max = 80;
  const iv = setInterval(() => {
    if (document.querySelector(BTN_SELECTOR)) bindAll();
    if (
      document.querySelector(WRAP_SELECTOR) &&
      document.querySelector(BTN_SELECTOR)
    ) {
      clearInterval(iv);
      ensureConfirmModal();
    }
    if (++tries > max) clearInterval(iv);
  }, 250);

  const mo = new MutationObserver((mutations) => {
    const shouldRebind = mutations.some((mut) => {
      if (mut.type === "childList") {
        return Array.from(mut.addedNodes).some(
          (node) =>
            node.nodeType === 1 &&
            ((node.matches && node.matches(BTN_SELECTOR)) ||
              (node.querySelector && node.querySelector(BTN_SELECTOR))),
        );
      }
      return false;
    });

    if (shouldRebind) {
      bindAll();
    }
  });
  mo.observe(document.documentElement, { childList: true, subtree: true });
}
